/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Harden_Detail6Inputs */

const en_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardrails, cost limits, logging, and fallback behavior before production.`)
};

const ar_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضوابط أمان وحدود تكلفة وتسجيل وسلوك احتياطي قبل الإنتاج.`)
};

const bn_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাকশনের আগে গার্ডরেল, কস্ট লিমিট, লগিং ও ফলব্যাক বিহেভিয়ার।`)
};

const de_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitplanken, Kostengrenzen, Protokollierung und Fallback-Verhalten vor der Produktion.`)
};

const es_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardrails, límites de costos, registro y comportamiento alternativo antes de la producción.`)
};

const fr_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardrails, limites de coûts, journalisation et comportement de repli avant la production.`)
};

const pt_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardrails, limites de custo, registro e comportamento alternativo antes da produção.`)
};

const zh_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产前的护栏、成本限制、日志记录和回退行为。`)
};

const tr_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üretim öncesi guardrail'ler, maliyet tavanları, loglama ve geri dönüş davranışı.`)
};

const ru_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гардрейлы, лимиты затрат, логирование и фолбэк-поведение до продакшена.`)
};

const pl_svc_ai_agent_development_harden_detail6 = /** @type {(inputs: Svc_Ai_Agent_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardraile, limity kosztów, logowanie i zachowanie fallbackowe przed produkcją.`)
};

/**
* | output |
* | --- |
* | "Guardrails, cost limits, logging, and fallback behavior before production." |
*
* @param {Svc_Ai_Agent_Development_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_harden_detail6 = /** @type {((inputs?: Svc_Ai_Agent_Development_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_harden_detail6(inputs)
	if (locale === "de") return de_svc_ai_agent_development_harden_detail6(inputs)
	if (locale === "es") return es_svc_ai_agent_development_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_harden_detail6(inputs)
	return en_svc_ai_agent_development_harden_detail6(inputs)
});
export { svc_ai_agent_development_harden_detail6 as "svc_ai-agent-development_HARDEN_detail" }